import MedReqStatusBadge from '@/components/shared/MedReqStatusBadge'
import { formatDateTime } from '@/lib/utils'
import type { MedReqListItem } from '@/services/med-requests'
import { Tooltip } from '@mui/material'
import type { GridColDef, GridRenderCellParams } from '@mui/x-data-grid'

export type MedReqRow = Omit<MedReqListItem, 'modifiedAt'> & {
  modifiedAt: Date | null
}

export const columns: GridColDef<MedReqRow>[] = [
  {
    field: 'hash',
    headerName: 'Hash',
    flex: 1,
    minWidth: 200,
    renderCell: (params: GridRenderCellParams<MedReqRow, string>) => {
      if (!params.value) return '-'

      return (
        <Tooltip title={params.value}>
          <span>{params.value.slice(0, 8)}</span>
        </Tooltip>
      )
    }
  },
  {
    field: 'orderNumber',
    headerName: 'Order Number',
    flex: 1,
    minWidth: 180,
    valueGetter: (_value, row) => row.orderNumber ?? '-'
  },
  {
    field: 'patientFullName',
    headerName: 'Patient',
    flex: 1,
    minWidth: 160,
    valueGetter: (_value, row) => row.patientFullName ?? '-'
  },
  {
    field: 'medicationName',
    headerName: 'Medication',
    flex: 1.5,
    minWidth: 200,
    renderCell: (params: GridRenderCellParams<MedReqRow, string>) => (
      <Tooltip title={params.value}>
        <span>{params.value ?? '-'}</span>
      </Tooltip>
    )
  },
  {
    field: 'orderItemStatus',
    headerName: 'Status',
    minWidth: 160,
    renderCell: (params: GridRenderCellParams<MedReqRow, string>) => <MedReqStatusBadge status={params.value ?? ''} />
  },
  {
    field: 'lastUpdatedBy',
    headerName: 'Last updated by',
    flex: 1,
    minWidth: 150,
    sortable: false,
    valueGetter: (_value, row) => row.lastUpdatedBy?.name || '-'
  },
  {
    field: 'modifiedAt',
    headerName: 'Last updated on',
    flex: 1,
    minWidth: 200,
    type: 'dateTime',
    valueFormatter: value => (value ? formatDateTime(value) : '-')
  }
]

/** Filterable but not rendered: notes are too long for a row, Patient Response is derived from hold history. */
export const MED_REQ_FILTER_ONLY_COLUMNS: GridColDef[] = [
  { field: 'csNotes', headerName: 'CS Notes' },
  { field: 'pharmacistNotes', headerName: 'Pharmacist Notes' },
  { field: 'patientResponse', headerName: 'Patient Response', type: 'boolean' }
]
